import request from '@/utils/request'

let getNotification=(data)=>request.get('/api/notifyContent/get',data)
let setNotification=(data)=>request.post('/api/notifyContent/update',data)
let sendNotification=(data)=>request.post('/api/notify/send',data,{'content-type':'multipart/form-data'})
let sendSingleNotification=(data)=>request.post('/api/notify/sendSingleImei',data)
export default {
  getNotification,
  setNotification,
  sendNotification,
  sendSingleNotification
}